import DataTable, { defaultThemes } from 'react-data-table-component';
import { IClientes } from '../../interfaces/IClientes';

const ClientesTabela = ({ colunas, itens }: { colunas: any, itens: IClientes[] }) => {

  const customStyles = {
    headCells: {
      style: {
        width: '200px',
        color: '#5E6397',
        fontFamily: 'Assistant',
        fontSize: '16px',
        paddingTop: '15px',
        paddingBottom: '6px',
        ':last-child': {
          maxWidth: '160px',
          borderRightStyle: 'solid',
          borderRightWidth: '1px',
          borderRightColor: defaultThemes.default.divider.default
        },
        ':nth-child(4n)': {
          maxWidth: '80px'
        },
        ':nth-child(2n)': {
          maxWidth: '180px'
        },
        ':first-child': {
          borderLeftStyle: 'solid',
          borderLeftWidth: '1px',
          borderLeftColor: defaultThemes.default.divider.default
        },
        borderTopStyle: 'solid',
        borderTopWidth: '1px',
        borderTopColor: defaultThemes.default.divider.default
      },
    },
    cells: {
      style: {
        width: '200px',
        color: '#A3A3A3',
        fontFamily: 'Merriweather Sans',
        fontSize: '1.000em',
        paddingTop: '15px',
        paddingBottom: '6px',
        ':last-child': {
          maxWidth: '160px',
          borderRightStyle: 'solid',
          borderRightWidth: '1px',
          borderRightColor: defaultThemes.default.divider.default
        },
        ':nth-child(4n)': {
          maxWidth: '80px'
        },
        ':nth-child(2n)': {
          maxWidth: '180px'
        },
        ':first-child': {
          borderLeftStyle: 'solid',
          borderLeftWidth: '1px',
          borderLeftColor: defaultThemes.default.divider.default,
          color: '#525252'
        },
        borderBottomStyle: 'solid',
        borderBottomWidth: '1px',
        borderBottomColor: defaultThemes.default.divider.default
      }
    }
  };

  return <>
    { 
      itens.length > 0 ? 
        <DataTable columns={colunas} data={itens} customStyles={customStyles} dense /> 
      :
        <h2 className="mt-5">Não possuem Empreasas para serem exibidas</h2>
    }            
  </>
}

export default ClientesTabela;